import { makeStyles } from '@material-ui/core/styles';
import { fontSizePxToRem, setPadding } from 'helpers/functions';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: '#FFFFFF',
    border: '1px solid #000',
    padding: '20px 15px 10px 15px',
    margin: '0px 30px 12px 0px',
  },
  header: {
    color: theme.palette.primary.contrastText,
    fontSize: fontSizePxToRem(15),
  },
  text: {
    color: theme.palette.primary.contrastText,
    fontSize: fontSizePxToRem(17),
    fontWeight: 600,
  },
  mainPrintTemplate: { backgroundColor: '#fff' },
  topInfo: {
    display: 'flex',
  },
  logoArea: {
    ...setPadding(null, 20, null, null),
  },
  ticketName: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '10px',
  },
  ownerInfo: {
    padding: '16px 0',
  },
  requestedBy: {
    ...setPadding(32, null, null, null),
  },
  invoiceNumber: {
    ...setPadding(null, null, 16, null),
  },
}));

export default useStyles;
